module.exports = require("core-js/library/fn/parse-int");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/parse-int.js